import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { TokenStorageService } from '../services/token-storage.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
const TOKEN_HEADER_KEY = 'Authorization';       // for Spring Boot back-end
const GEOJSON_API = environment.geoJsonApi;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private token: TokenStorageService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipAuth = req.headers.has('X-Skip-Auth');
    const skipAuthRedirect = req.headers.has('X-Skip-Auth-Redirect');
    if (skipAuth || skipAuthRedirect) {
      req = req.clone({
        headers: req.headers
          .delete('X-Skip-Auth')
          .delete('X-Skip-Auth-Redirect')
      });
    }

    const token = this.token.getToken();
    if (token != null && !skipAuth) {
      if( ![GEOJSON_API].includes(req.url)){
      let headers = req.headers
        .set('Authorization', `Bearer ${token}`);

        const isFormData = req.body instanceof FormData;
        if (!isFormData) {
          headers = headers.set('Content-Type', 'application/json');
        }
      //authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
      req = req.clone({ headers });}

    }
    //return next.handle(authReq);
    return next.handle(req).pipe(tap(() => { },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          } else if (skipAuthRedirect) {
            return;
          } else {
            this.token.isLoggedOut();
            if (this.router.url.includes('/manage')) {
              this.router.navigateByUrl("/manage/login");
            } else {
              this.router.navigateByUrl("/home");
            }
          }
        }
      }));
  }
}
